import { useEffect, useRef } from 'react'
import { IconX } from '@tabler/icons-react'

const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'

export default function Modal({ open, onClose, title, children, variant = 'default' }) {
  const panelRef = useRef(null)
  const previousFocus = useRef(null)

  useEffect(() => {
    if (!open) return
    previousFocus.current = document.activeElement
    const first = panelRef.current?.querySelector(FOCUSABLE)
    if (first) first.focus()

    function trapFocus(e) {
      if (e.key !== 'Tab') return
      const els = Array.from(panelRef.current?.querySelectorAll(FOCUSABLE) || [])
      if (!els.length) return
      const first = els[0], last = els[els.length - 1]
      if (e.shiftKey ? document.activeElement === first : document.activeElement === last) {
        e.preventDefault()
        ;(e.shiftKey ? last : first).focus()
      }
    }

    function onEsc(e) { if (e.key === 'Escape') onClose() }

    document.addEventListener('keydown', trapFocus)
    document.addEventListener('keydown', onEsc)
    return () => {
      document.removeEventListener('keydown', trapFocus)
      document.removeEventListener('keydown', onEsc)
      previousFocus.current?.focus()
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <>
      <div
        className="tg-scrim is-open"
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        ref={panelRef}
        className="tg-modal is-open"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        style={variant === 'destructive' ? { borderTop: '3px solid var(--tg-danger-500)' } : undefined}
      >
        <div className="tg-modal__head">
          <h2 className="tg-modal__title">{title}</h2>
          <button className="tg-icon-btn" onClick={onClose} aria-label="Close">
            <IconX size={20} />
          </button>
        </div>
        <div className="tg-modal__body">
          {children}
        </div>
      </div>
    </>
  )
}
